import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

const Navigation = () => {
  const location = useLocation();
  const [user, setUser] = useState(authService.getUser());
  
  useEffect(() => {
    // Загружаем информацию о пользователе при монтировании компонента
    const loadUser = async () => {
      await authService.loadUserInfo();
      setUser(authService.getUser());
    };
    loadUser();
    
    // Также слушаем изменения авторизации
    const handleAuthChange = () => {
      setUser(authService.getUser());
    };
    window.addEventListener('auth-change', handleAuthChange);
    
    return () => {
      window.removeEventListener('auth-change', handleAuthChange);
    };
  }, []);
  
  const currentServer = authService.currentServer || 'local';
  const serverNames = {
    local: 'Local',
    stage: 'Stage',
    production: 'Production'
  };

  const handleLogout = async () => {
    await authService.logout();
    // Навигация произойдет автоматически через App.js
  };

  const allPolunioVersions = [
    { id: 'polunio16', name: 'Mercantile Brace', path: '/mercantile-brace', section: 'mercantilebrace' },
    { id: 'polunio13', name: 'Artisan Beazley', path: '/artisan-evolve', section: 'artisanevolve' },
    { id: 'polunio12', name: 'WDBB Satinwood', path: '/wdbb-satinwood', section: 'wdbbsatinwood' },
    { id: 'polunio11', name: 'WDBB Hiscox', path: '/wdbb-hiscox', section: 'wdbbhiscox', disabled: true },
    { id: 'polunio10', name: 'CMR', path: '/cmr', section: 'cmr', disabled: true },
    { id: 'polunio9', name: 'BR', path: '/br', section: 'br', disabled: true },
    { id: 'polunio8', name: 'DF', path: '/df', section: 'df', disabled: true },
    { id: 'polunio7', name: 'HO', path: '/ho', section: 'ho', disabled: true },
    { id: 'polunio5', name: 'Mercantile', path: '/mercantile', section: 'mercantile', disabled: true },
    { id: 'polunio4', name: 'VP', path: '/vp', section: 'vp', disabled: true },
  ];

  // Фильтруем разделы на основе доступа пользователя
  const polunioVersions = allPolunioVersions.filter(version => {
    if (!user || !user.accessOnly || user.accessOnly.length === 0) {
      return false; // Если accessOnly не задан или пустой, скрываем все разделы
    }
    const hasAccess = user.accessOnly.includes(version.section);
    return hasAccess;
  });

  return (
    <nav className="nav">
      <ul>
        <li>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
        </li>
        {polunioVersions.map(version => (
          <li key={version.id}>
            {version.disabled ? (
              <button 
                onClick={(e) => e.preventDefault()} 
                style={{ 
                  opacity: 0.5, 
                  cursor: 'not-allowed',
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  padding: '14px 20px',
                  font: 'inherit',
                  width: '100%',
                  textAlign: 'left'
                }}
                title="Coming soon"
                disabled
              >
                {version.name}
              </button>
            ) : (
              <Link 
                to={version.path} 
                className={location.pathname === version.path ? 'active' : ''}
              >
                {version.name}
              </Link>
            )}
          </li>
        ))}
        <li style={{ marginLeft: 'auto', marginRight: '15px' }}>
          <span style={{
            color: 'white',
            fontSize: '14px',
            padding: '5px 10px',
            backgroundColor: currentServer === 'production' ? '#dc3545' : currentServer === 'stage' ? '#ffc107' : '#28a745',
            borderRadius: '4px',
            fontWeight: '500'
          }}>
            {serverNames[currentServer]}
          </span>
        </li>
        <li style={{ marginRight: '20px' }}>
          <button 
            onClick={handleLogout}
            style={{
              background: 'white',
              border: '1px solid #ddd',
              padding: '5px 15px',
              cursor: 'pointer',
              borderRadius: '4px',
              color: '#333',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Logout
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;